<template>
  <section class="mt-4 d-flex justify-content-center text-center">
    <div class="card d-flex justify-content-center shadow-lg p-3 mb-5 bg-white rounded " style="width: 35rem">
        <h2 class="text-center mb-2 font-weight-bolder">🅱️!BukaPasar</h2>
        <h2 class="text-center mb-5">Selamat Datang di BukaPasar</h2>

        <h4>Daftar akun baru sekarang</h4>
        <img src="" alt="">
        <div class="card-body">
          <form @submit.prevent="register" class="was-validated">
            <div class="form-group">
                <input type="email" class="form-control" v-model="email" placeholder="Enter email" name="email" required>
                <div class="valid-feedback">Valid.</div>
                <div class="invalid-feedback">Please fill out this field.</div>
            </div>
            <div class="form-group">
                <input type="password" class="form-control" v-model="password" placeholder="Enter password" name="password" required>
                <div class="valid-feedback">Valid.</div>
                <div class="invalid-feedback">Please fill out this field.</div>
            </div>
                <button type="submit" class="btn btn-success mb-5">Daftar</button>
          </form>
          <div>Sudah punya akun? <button @click="toFormlogin" class="btn btn-outline-success">Silahkan login</button> </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name : 'Register',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods : {
      toFormlogin () {
          this.$router.push('/login')
      },
      register () {
        const payload = {
          email : this.email,
          password : this.password
        }
        this.$store.dispatch('register', payload)
      }
  }
}
</script>

<style>

</style>